export default __webpack_public_path__ + "static/media/Template_4_dark.966f0a81.svg";